export const REASON_OF_ADDING_CONTACT =
  'It is imperative to have a contact for each business in case there are any questions from our office regarding the filings. Please ensure there is an accurate phone and email for individuals to have access to your account. Please review and remove any former employers or employees that no longer should have access to ensure your proprietary information is kept private.';

export const TITLE = 'Importance of Adding a Contact';
